import React from 'react';
import { useFormat } from '@frontastic-engbers/helpers/hooks/useFormat';
type Props = {
  condition: boolean;
  /**
   * message can either be the message that should be displayed
   * or an error translation (from public/locales/[lang]/error.json)
   */
  message: string;
  id?: string;
};
export const InputError: React.FC<Props> = ({
  condition,
  message,
  id
}) => {
  const {
    formatMessage
  } = useFormat({
    name: 'error'
  });
  if (!condition) {
    return null;
  }
  return <span className='text-danger text-xs' id={id} role='alert' data-sentry-component="InputError" data-sentry-source-file="index.tsx">
      {formatMessage({
      id: message
    })}
    </span>;
};